import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Avatar from "@mui/material/Avatar";
import React from "react";

const UserAvatar = ({ name }) => {
  if (name === "Guest") {
    return (
      <AccountCircleIcon
        className="initial-circle"
      />
    );
  }
  return (
    <Avatar
      className="avatar"
    >
      {name || "?"}
    </Avatar>
  );
};

export default UserAvatar;
